import React from 'react';

import { Icon } from '@betterment/samba-react';

const ReffableIcon = React.forwardRef<HTMLSpanElement, React.ComponentProps<typeof Icon>>((props, ref) => (
  <span ref={ref}>
    <Icon {...props} />
  </span>
));

export default ReffableIcon;
